import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';

function SubMenuItem({ children, inverse = false, title }) {
    const classes = cns('dropdown__listItem subMenu', {
        inverse,
    });
    return (jsxs("li", { className: classes, "data-clickable": "false", role: "menuitem", children: [jsx("span", { "data-clickable": "false", children: title }), jsx("ul", { className: "dropdown__list", role: "menu", children: children })] }));
}

export { SubMenuItem as default };
